import classNames from 'classnames';
import React from 'react';

export const PageContainer = ({
  className,
  ...props
}: React.ComponentProps<'div'>) => {
  return (
    <div
      className={classNames('custom-collapse-page-container', className)}
      {...props}
    />
  );
};
export default PageContainer;
